import React from "react";
import Select from "../../Common/FormElements/Select/Select";
import ListDeleteIcon from "../../Common/DeleteIcon/ListDeleteIcon";

function IntermediaryItem({ value, options, handleChange, removeField }) {
  return (
    <div className="alignH py-3 px-3 b-1-bottom-softGrey">
      <Select
        options={options}
        width="w50"
        placeholder="Sélectionner"
        valueCustomStyle="12px"
        value={value}
        callback={handleChange}
      />
      <ListDeleteIcon callback={removeField} />
    </div>
  );
}

export default IntermediaryItem;
